import React,{useState,useEffect} from 'react'
import Footer from '../inc/Footer';
import Loader from '../inc/Loader';
import axios from 'axios';
import '../inc/GlobalVars';
import { ToastContainer, toast } from 'react-toastify';

function ChangePassword() {

    const[loading,setLoading] = useState(false);
    const user_id = localStorage.getItem('userId');
    const [inputData,setInputData] = useState({password:"",new_pass:"",conf_pass:"",user_id:user_id});

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(inputData.new_pass != inputData.conf_pass)
        {
            toast.error('New Password and Retype Password Not Matching', {
                position: "top-left",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
        }
        else
        {
            setLoading(true);
try {
        const resp = await  axios.post(global.apiUrl+'/updateUserPassword',inputData).then(function(response)
        {
            setLoading(false);
            let status= response.data['status'];
            //console.log(response);
            if(status == 400)
            {
                toast.error('Wrong Old Password', {
                    position: "top-left",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else
            {
                toast.success('Password Updated Successfully', {
                    position: "top-left",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
    
        }
    
        )
       }
       catch (e)
       {
        console.log(e);
       }
        }
        console.log(inputData);
       
    }
  return (
    
    <div>
        <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
        {loading ? ( <Loader /> ) : (
<>

      <div className="container mb-5">
          <div className="row">
            <div className="col-md-12 mb-5  mt-5 pt-5">
              <h1 style={{textTransform:"capitalize"}}>Update Password</h1>
            </div>
          </div>

          <div className='row'>
            <form method='POST' encType='multipart/form-data'>
            <div className='row mb-2'>
                
                        <div className='col-md-12 mb-2'>
                            <label>Old Password<span className='text-danger'>*</span></label>
                            <input type='password' name="password" onChange={e => setInputData({...inputData,password:e.target.value})} className='form-control' placeholder='Enter Old Password' required />
                        </div>
                        <div className='col-md-12 mb-2'>
                            <label>New Password<span className='text-danger'>*</span></label>
                            <input type='password' name="new_pass"  onChange={e => setInputData({...inputData,new_pass:e.target.value})} className='form-control' placeholder='Enter New Password' required />
                        </div>
                        <div className='col-md-12 mb-2'>
                            <label>Retype Password<span className='text-danger'>*</span></label>
                            <input type='password' name="conf_pass"  onChange={e => setInputData({...inputData,conf_pass:e.target.value})} className='form-control' placeholder='Retype New Password' required />
                        </div>
                        </div>
                        

                        <button className='btn btn-primary default-button' onClick={handleSubmit}>Update Password</button>

            </form>
          </div>
        </div>
      
     
        <Footer />

        
</> )}</div> );
  
}

export default ChangePassword